import { Heading, VStack, Input, Button, Box, Table, Thead, Tbody, Tr, Th, Td, Select, useToast, Checkbox, Text, useColorModeValue, useDisclosure, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, ModalCloseButton, Collapse, HStack } from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Tooltip } from "@chakra-ui/react";
import { FiEdit, FiCheck, FiX , FiTrash} from "react-icons/fi";
import { jwtDecode } from "jwt-decode";

interface Tenant {
  tenant_id: number;
  name: string;
  description: string;
  is_active: boolean;
}

interface User{
    user_id : number;
    username : string;
    email : string;
    password : string;
    tenant_id : number;
    role_id:number;
    is_active : boolean;
}

// Define the expected structure of the token payload
interface TokenPayload {
  sub: string;       // Typically the username or user ID
  role_id: number;   // Role ID
  tenant_id: number; // Tenant ID
  exp?: number;      // Expiration timestamp (optional)
}

interface UserUpdateTableProps {
    tenant_id: number; 
    role_id : number;
  }

const UserUpdateTable: React.FC<UserUpdateTableProps> = ({ tenant_id, role_id}) => {
 
  const [userRole, setUserRole] = useState<string | null>(null);


  const [users, setUsers] = useState<User[]>([]);
  const [editRow, setEditRow] = useState<number | null>(null); // Track the row currently being edited

  const toast = useToast();

  const tableHeaderbg = useColorModeValue("gray.200", "gray.700");

  
  useEffect(() => {
    if(role_id == 2)
    {
        setUserRole("admin");
    
    }
    else if(role_id == 3)
    {
        setUserRole("tutor");
      
    }
    else if(role_id == 4)
    {
        setUserRole("student");
  
    }
    }, [userRole])

  // Fetch users when userRole or tenant_id changes
  useEffect(() => {
    if (userRole && tenant_id) {
      fetchUsers();
    }
  }, [userRole, tenant_id]); // Add dependencies

  const fetchUsers = async () => {
    try {
        const tenantsapiurl = process.env.REACT_APP_TENANTS_API_URL || 'https://default-url.com';
        const response = await axios.get(tenantsapiurl + `/${tenant_id}/${userRole}-users`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      setUsers(response.data);
    } catch (error) {
      console.error("Failed to load users", error);
    }
  };


  const handleUpdateAdmin = async (user: User) => {

    try {
            const payload = {
                username: user.username,
                email: user.email,
                password: user.password,
                tenant_id: tenant_id,
                role_id: role_id,
                is_active: user.is_active,
            };
          const apiurl = process.env.REACT_APP_API_URL || 'https://default-url.com';
     
      console.log("Printing Token from Update" + localStorage.getItem("token"));
      await axios.put(apiurl+`/update-user/${user.user_id}`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      fetchUsers();
      setEditRow(null); // Reset edit mode after successful update
      toast({ title: "User updated successfully", status: "success" });
    } catch (error) {
      console.error("Failed to update User", error);
      toast({ title: "Failed to update User", status: "error" });
    }
  };

  const handleDeleteUser = async (user_id: number) => {

    try {
          const apiurl = process.env.REACT_APP_API_URL || 'https://default-url.com';
     
      console.log("Printing Token from Update" + localStorage.getItem("token"));
      await axios.delete(apiurl+`/delete-user/${user_id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      fetchUsers();
      setEditRow(null); // Reset edit mode after successful update
      toast({ title: "User deleted successfully", status: "success" });
    } catch (error) {
      console.error("Failed to delete User", error);
      toast({ title: "Failed to delete User", status: "error" });
    }
  };

  const handleEditRow = (user_id: number) => {
    setEditRow(user_id);

  };

  const handleCancelEdit = () => {
    setEditRow(null);

  };

  return (
    <Box >
        <Table mt={4} borderColor={"gray.300"} borderWidth={1} borderRadius="sm">
          <Thead>
            <Tr bgColor={tableHeaderbg}>
              <Th>ID</Th>
              <Th>Username</Th>
              <Th>Email</Th>
              <Th>Password</Th>
              <Th>Active</Th>
              <Th>Actions</Th>
            </Tr>
          </Thead>
          <Tbody fontSize="sm">
            {users.map((user) => (
              <Tr key={user.user_id} opacity={editRow && editRow !== user.user_id ? 0.5 : 1}>
                <Td>{user.user_id}</Td>
                <Td>
                  {editRow === user.user_id ? (
                    <Input
                      size="sm" // Control the input size here
                      fontSize="sm" // Control font size inside input
                      value={user.username}
                      onChange={(e) => {
                        user.username = e.target.value;
                        setUsers([...users]);
                      }}
                    />
                  ) : (
                    user.username
                  )}
                </Td>
                <Td>
                  {editRow === user.user_id ? (
                    <Input
                    size="sm" // Control the input size here
                      fontSize="sm" // Control font size inside input
                      value={user.email}
                      onChange={(e) => {
                        user.email = e.target.value;
                        setUsers([...users]);
                      }}
                    />
                  ) : (
                    user.email
                  )}
                </Td>
                <Td>
                  {editRow === user.user_id ? (
                    <Input
                    size="sm" // Control the input size here
                      fontSize="sm" // Control font size inside input
                      placeholder="Enter to Reset Password"
                      value={user.password}
                      onChange={(e) => {
                        user.password = e.target.value;
                        setUsers([...users]);
                      }}
                    />
                  ) : (
                    user.password
                  )}
                </Td>
                <Td>
                  {editRow === user.user_id ? (
                    <Checkbox
       
                      isChecked={user.is_active}
                      onChange={(e) => {
                        user.is_active = e.target.checked;
                        setUsers([...users]);
                      }}
                    />
                  ) : user.is_active ? "Active" : "Inactive"}
                </Td>
                <Td>
                  { editRow === user.user_id ? (
                    <HStack>
                      <Tooltip label="Update">
                        <Button size="sm" onClick={() => handleUpdateAdmin(user)}><FiCheck /></Button>
                      </Tooltip>
                      <Tooltip label="Cancel">
                        <Button size="sm" ml={2} onClick={handleCancelEdit}><FiX /></Button>
                      </Tooltip>
                      </HStack>
                  ) : (
                    <HStack>
                    <Tooltip label="Edit">
                      <Button size="sm" onClick={() => handleEditRow(user.user_id)}><FiEdit /></Button>
                    </Tooltip>
                    <Tooltip label="Delete">
                    <Button size="sm" colorScheme="red" onClick= {() => {
                            if (window.confirm("Are you sure you want to delete this user?")) {
                              handleDeleteUser(user.user_id);
                            }
                          }}><FiTrash  /></Button>
                  </Tooltip>
                  </HStack>
                  )}
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
  );
};

export default UserUpdateTable;
